export enum HealthReportsActions {
    FETCH_REPORTS = 'FETCH_REPORTS',
    DOWNLOAD_REPORT = 'DOWNLOAD_REPORT',
    FETCH_CUSTOMERS = 'FETCH_CUSTOMERS',
    SEARCH_CUSTOMER = 'SEARCH_CUSTOMER',
    CHANGE_PAGE = 'CHANGE_PAGE',
    UPLOAD_REPORT = 'UPLOAD_REPORT',
}
